// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import './style/reset-css.css'
import './style/element-variables.scss'
import './style/zyyj-common.css'
import 'font-awesome/css/font-awesome.min.css'
import './font/iconfont.css'

import _ from 'lodash'
import Vue from 'vue'
import axios from 'axios'
import ElementUI from 'element-ui'
import * as echarts from 'echarts'
import { abilitiesPlugin } from '@casl/vue'
import md5 from 'js-md5'

import App from './App'
import router from './router'
import store from './store'
import {
  xhrGet,
  xhrPost,
  xhrPut,
  xhrPatch,
  xhrDelete,
  xhrFilePost,
  xhrFilePut,
  fetchFile,
  fetchPdf,
  isTimeIntervalOverHalfOneHour,
  isTimeIntervalOverOneHour,
  requestNewToken
} from './util/xhr-apis'
import './util/vue-filters'
import './util/v-directive'
import { generateEchartsPie } from './util/echarts/echarts-pie'

import regional from '../config/regional.configuration'
import dayjs from 'dayjs'
import VueBus from 'vue-bus'
import { hasMenu } from '@/util/prowers'
import(`../theme/index.css`)
// import('./util/browser-logger')

Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.use(abilitiesPlugin)
Vue.prototype.$echarts = echarts
Vue.use(VueBus)

Vue.prototype.$xhrGet = xhrGet
Vue.prototype.$xhrPost = xhrPost
Vue.prototype.$xhrPut = xhrPut
Vue.prototype.$xhrDelete = xhrDelete
Vue.prototype.$xhrPatch = xhrPatch
Vue.prototype.$xhrFilePost = xhrFilePost
Vue.prototype.$xhrFilePut = xhrFilePut
Vue.prototype.$fetchFile = fetchFile
Vue.prototype.$fetchPdf = fetchPdf
Vue.prototype.$md5 = md5
Vue.prototype.$regional = regional
Vue.prototype.$dayjs = dayjs
Vue.prototype.$generateEchartsPie = generateEchartsPie
Vue.prototype.$hasMenu = hasMenu

const defaultTitle = '学生综合素质评价系统'
router.beforeEach(async (to, from, next) => {
  document.title = to.meta.title ? to.meta.title : defaultTitle
  if (
    to.name === 'Login' ||
    to.name === 'Register' ||
    to.name === 'ForgetPwd'
  ) {
    next()
    return
  } else {
    // 记录 请求token接口时间、上一次请求时间
    // eslint-disable-next-line
    let requestTokenTime =
      Number(localStorage.getItem('requestTokenTime')) || null
    // eslint-disable-next-line
    let lastRequestTime =
      Number(localStorage.getItem('lastRequestTime')) || null

    const now = new Date().getTime()

    try {
      if (isTimeIntervalOverHalfOneHour(now, requestTokenTime)) {
        if (isTimeIntervalOverOneHour(now, lastRequestTime)) {
          setTimeout(() => {
            this.$message.error('会话过期，请重新登录')
          }, 200)
          await axios.get(`/acc/user/logout`)
          return false
        } else {
          // 获取新token
          const result = await requestNewToken()
          if (result && result.access_token) {
            window.localStorage.setItem('token', result.access_token)
            window.localStorage.setItem('refreshToken', result.refresh_token)
            requestTokenTime = new Date().getTime()
            window.localStorage.setItem('requestTokenTime', requestTokenTime)
            lastRequestTime = new Date().getTime()
            window.localStorage.setItem('lastRequestTime', lastRequestTime)
          }
        }
      }
    } catch (error) {
      console.log(error)
    } finally {
    }
  }
  // if (!store.state.user || !store.state.user.name || store.state.user.name === 'anon') {
  // if (to.meta.requireAuth || to.meta.requireAuth === undefined || to.name === null) {
  //   next({ name: 'Login', query: { redirect: to.path } })
  // }
  // }
  /* brower refresh? */
  // if (Vue.prototype.$ability.rules.length === 0 && store.state.user.rules && store.state.user.rules.length > 0) {
  //   Vue.prototype.$ability.update(store.state.user.rules)
  // }
  /* if allow brower history back botton */
  if (_.includes(from.meta.preventGoBacks, to.name)) {
    next(false)
    return
  }
  next()
})

// window.onbeforeunload = function(e) {
//   // 刷新操作无法根据URL匹配第二级菜单
//   var dialogText = ''
//   e.returnValue = dialogText
//   return dialogText
// }

const BrowserLogger = require('alife-logger')
const _bl = BrowserLogger.singleton({
  pid: 'd7h4jkfiec@c61be054c11217b',
  appType: 'web',
  imgUrl: 'https://arms-retcode.aliyuncs.com/r.png?',
  sendResource: true,
  enableLinkTrace: true,
  behavior: true,
  environment: process.env.NODE_ENV === 'production' ? 'prod' : 'local',
  disabled: process.env.NODE_ENV !== 'production',
  enableSPA: true
})
console.log('BrowserLogger', _bl)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js